module.exports = __webpack_public_path__ + "img/content_2.b0e71567.png";